import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useOnboarding, OnboardingStep } from '../../contexts/OnboardingContext';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EmailIcon from '@mui/icons-material/Email';
import { useBusinessTheme } from '../../contexts/BusinessThemeContext';

const UsersGuide: React.FC = () => {
  const { isOnboarding, currentStep, isAdminUser } = useOnboarding();
  const { theme: businessTheme } = useBusinessTheme();

  // Only show for admin users in the Users step
  if (!isOnboarding || 
      currentStep !== OnboardingStep.Users || 
      !isAdminUser) {
    return null;
  }

  // Use business theme colors
  const primaryColor = businessTheme?.navigationColor || '#2196f3';
  const backgroundColor = businessTheme?.subtleAccent || '#f5f7fa';
  const textColor = businessTheme?.textColor || '#333333';

  return (
    <Box sx={{ position: 'relative', mb: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          mt: 2, 
          borderLeft: `4px solid ${primaryColor}`, 
          bgcolor: backgroundColor,
          color: textColor
        }}
      >
        <Typography variant="h6" sx={{ mb: 1, fontWeight: "bold" }}>
          Add Team Members
        </Typography>
        <Typography variant="body1" paragraph>
          Invite your colleagues to join your business on MindShare:
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <PersonAddIcon sx={{ mr: 1, color: primaryColor }} />
          <Typography variant="body1" fontWeight="medium">
            Create User Accounts
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ mb: 3, pl: 4 }}>
          Add team members by entering their details and email addresses. Each member will receive an invitation to join.
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <AssignmentIndIcon sx={{ mr: 1, color: primaryColor }} />
          <Typography variant="body1" fontWeight="medium">
            Assign Roles
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ mb: 3, pl: 4 }}>
          Select the appropriate role for each user based on their responsibilities within your organization.
        </Typography>
        
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <EmailIcon sx={{ mr: 1, color: primaryColor }} />
          <Typography variant="body1" fontWeight="medium">
            Send Invitations
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ pl: 4 }}>
          Once added, team members will receive an email with instructions to set up their account and start using MindShare.
        </Typography>
      </Paper>
    </Box>
  );
};

export default UsersGuide; 